module.exports = __webpack_public_path__ + "media/customizations/riverstone/logo-a2afb00f9b484aef4e5a627856a42565.png";